import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-383">
      <SEO title="Cookie Policy | KittyPot" description="How KittyPot, a shared expense and settlement tracker, uses cookies and similar technologies on our website." ogTitle="KittyPot Cookie Policy" ogDescription="How KittyPot uses cookies on our website." path="/cookie-policy" data-id="element-384" />
      <Navbar data-id="element-385" />
      <main className="pt-32 pb-24" data-id="element-386">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-387">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-388">
            Cookie Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-389">
            <p className="font-medium" data-id="element-390">Last updated: 14 December 2025</p>

            <p data-id="element-391">
              This Cookie Policy explains how KittyPot Ltd ("Company," "we,"
              "us," and "our") uses cookies and similar technologies to
              recognize you when you visit our website at
              https://www.kittypot.com ("Website"). It outlines what cookies
              are, why we use them, and your rights to control their usage.
            </p>

            <p data-id="element-392">
              In some cases, we may use cookies to collect personal information,
              or information that becomes personal when combined with other
              data.
            </p>

            <p data-id="element-393">
              Current MVP: KittyPot is for expense tracking and manual
              settlement only. KittyPot does not currently hold funds, process
              payments, issue cards, or provide regulated e-money services.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-394">
              1. WHAT ARE COOKIES?
            </h2>
            <p data-id="element-395">
              Cookies are small data files placed on your computer or mobile
              device when you visit a website. These files are commonly used by
              website owners to make websites work or perform more efficiently
              and to provide reporting data.
            </p>
            <p data-id="element-396">
              Cookies set by the website owner (in this case, KittyPot Ltd) are
              referred to as "first-party cookies." Cookies set by parties other
              than the website owner are known as "third-party cookies."
              Third-party cookies allow the provision of third-party services on
              the website (e.g., advertising, interactive content, and
              analytics). These third parties may recognize your computer when
              you visit our website as well as when you visit other websites.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-397">
              2. WHY DO WE USE COOKIES?
            </h2>
            <p data-id="element-398">
              We use both first- and third-party cookies for various reasons.
              Some cookies are essential for technical reasons to make our
              website operate ("essential" or "strictly necessary" cookies).
              Other cookies help us track and target the interests of our users
              to improve their experience.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-399">
              3. HOW CAN I CONTROL COOKIES?
            </h2>
            <p data-id="element-400">
              You have the right to decide whether to accept or reject cookies.
              You can manage your cookie preferences via the Cookie Consent
              Manager. Essential cookies cannot be rejected as they are strictly
              necessary for the functionality of the website.
            </p>
            <p data-id="element-401">
              The Cookie Consent Manager is available through the notification
              banner and on our website. If you choose to reject cookies, you
              can still use our website, but some features may not be
              accessible. You can also configure your web browser to accept or
              reject cookies.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-402">
              Performance and Functionality Cookies
            </h3>
            <p data-id="element-403">
              These cookies enhance the performance and functionality of our
              website but are not essential.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-404">
              <li data-id="element-405">
                <strong data-id="element-406">Name:</strong> TS#
              </li>
              <li data-id="element-407">
                <strong data-id="element-408">Purpose:</strong> Enhances website security.
              </li>
              <li data-id="element-409">
                <strong data-id="element-410">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-411">
                <strong data-id="element-412">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-413">
                <strong data-id="element-414">Expires:</strong> Session
              </li>
            </ul>
            <ul className="list-disc pl-5 space-y-2 mt-4" data-id="element-415">
              <li data-id="element-416">
                <strong data-id="element-417">Name:</strong> XSRF-TOKEN
              </li>
              <li data-id="element-418">
                <strong data-id="element-419">Purpose:</strong> Prevents Cross-Site Request Forgery
                (CSRF).
              </li>
              <li data-id="element-420">
                <strong data-id="element-421">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-422">
                <strong data-id="element-423">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-424">
                <strong data-id="element-425">Expires:</strong> Session
              </li>
            </ul>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-426">
              Analytics and Customisation Cookies
            </h3>
            <p data-id="element-427">
              These cookies help us understand how our website is used and
              improve user experience.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-428">
              <li data-id="element-429">
                <strong data-id="element-430">Name:</strong> bolt-performance
              </li>
              <li data-id="element-431">
                <strong data-id="element-432">Purpose:</strong> Tracks performance metrics
              </li>
              <li data-id="element-433">
                <strong data-id="element-434">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-435">
                <strong data-id="element-436">Type:</strong> Pixel Tracker
              </li>
              <li data-id="element-437">
                <strong data-id="element-438">Expires:</strong> Session
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-439">
              4. HOW CAN I CONTROL COOKIES ON MY BROWSER?
            </h2>
            <p data-id="element-440">
              You can manage cookies through your browser settings. Please refer
              to your browser's help section for guidance.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-441">
              <li data-id="element-442">Chrome</li>
              <li data-id="element-443">Firefox</li>
              <li data-id="element-444">Safari</li>
              <li data-id="element-445">Edge</li>
              <li data-id="element-446">Opera</li>
            </ul>
            <p className="mt-4" data-id="element-447">
              You can also opt out of targeted advertising via:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-448">
              <li data-id="element-449">Digital Advertising Alliance</li>
              <li data-id="element-450">European Interactive Digital Advertising Alliance</li>
              <li data-id="element-451">Digital Advertising Alliance of Canada</li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-452">
              5. OTHER TRACKING TECHNOLOGIES
            </h2>
            <p data-id="element-453">
              We may use web beacons (tracking pixels) to measure website
              traffic and campaign effectiveness. These rely on cookies to
              function.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-454">
              6. FLASH COOKIES
            </h2>
            <p data-id="element-455">
              We may use Flash cookies for fraud prevention and service
              functionality. You can manage Flash cookies via Adobe Flash Player
              settings.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-456">
              7. TARGETED ADVERTISING
            </h2>
            <p data-id="element-457">
              Third-party advertisers may place cookies to deliver
              interest-based advertising. They do not collect personal data
              unless you provide it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-458">
              8. POLICY UPDATES
            </h2>
            <p data-id="element-459">
              We may update this Cookie Policy periodically for legal,
              regulatory, or operational reasons.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-460">
              9. Unicorn Platform Cookies
            </h2>
            <p data-id="element-461">
              Our website is built using Unicorn Platform, which uses essential
              cookies required for core functionality.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-462">
              10. CONTACT US
            </h2>
            <p data-id="element-463">
              If you have any questions about this Cookie Policy, please contact
              us at support@kittypot.com or by post:
            </p>
            <address className="not-italic mt-4" data-id="element-464">
              KittyPot Ltd
              <br data-id="element-465" />
              Flat 2 Minavon
              <br data-id="element-466" />
              Cardiff
              <br data-id="element-467" />
              South Glamorgan
              <br data-id="element-468" />
              CF14 6BE
              <br data-id="element-469" />
              United Kingdom
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-470" />
    </div>;
}